// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/components/message/tooltips/TeamContainsFreeUsersTooltip.tsx
import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TrackUsageContext } from '../../../usage-tracking/contexts/TrackUsageContext';
// TODO: move this out of routing-rules
import { trackClickManagePaidUsers } from '../../../routing-rules/utils/event-handlers'; // TODO: move this out of routing-rules
import { getPaidUserSettingsUrl } from '../../../urls/getPaidUserSettingsUrl';
import { getUsersSeatsUrl } from '../../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TeamContainsFreeUsersTooltip({
  children,
  isNewSeatingModel
}) {
  const trackUsage = useContext(TrackUsageContext);
  const href = isNewSeatingModel ? getUsersSeatsUrl() : getPaidUserSettingsUrl();
  const title = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-on-fill-default",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isNewSeatingModel ? 'routing-ui.users-and-teams.tooltips.team-free-user-routing.needsSeatDescription' : 'routing-ui.users-and-teams.tooltips.team-free-user-routing.description'
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href,
      onClick: () => trackUsage(trackClickManagePaidUsers('team')),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isNewSeatingModel ? 'routing-ui.users-and-teams.tooltips.team-free-user-routing.manageSeatsLink' : 'routing-ui.users-and-teams.tooltips.team-free-user-routing.manage-link'
      })
    })]
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    children: children
  });
}
TeamContainsFreeUsersTooltip.displayName = 'TeamContainsFreeUsersTooltip';
export default TeamContainsFreeUsersTooltip;